// pc和h5接口基本一样 提取出来复用
import store from "../../store";
import request from '../../api/request'
import Storage from "../../api/storage";
import { Message } from "element-ui";
import urlParams from "../../api/urlParams";
import dayjs from 'dayjs'
import $ from 'jquery'
import { Toast } from "mint-ui";
import msgAudio from './../../../static/media/message.wav';
import transAudio from './../../../static/media/transfer.wav';

const timeLineFn = (store, data, flag) => {
    store.dispatch('setChatList', {
        senderType: 4,
        msgContent: `${flag ? window.vm.$i18n.t('today') : ''} ${dayjs(data).format('HH:mm')}`,
        msgTime: data
    })
}
let chatApi = {
    intervalId: null, // 轮训定时器
    adminTimeoutTimeId: null, // 客服超时提示分钟数
    userTimeoutTimeId: null, // 用户超时提示分钟数
    messageAudio: null, // 消息提示音
    isCustomer: false,// 是否是人工
    isCloseClick: false,
    isShowIframe: false,
    timeTyping: false, // 正在输入
    transferAudio: null,
    serverTime: 0 || new Date().getTime(),
    initData(loading) {
        this.messageAudio = new Audio(msgAudio)
        this.transferAudio = new Audio(transAudio)
        // 获取渠道配置
        request.getChatChannelInfo({ id: urlParams('channelId') }).then(result => {
            // document.title = result.data.tenantName;
            window.vm.$i18n.locale = urlParams('locale') || result.data.language || 'zh';
            let companyId = result.data.tenantId;
            if (urlParams('robotNo')) {
                result.data.robotNo = urlParams('robotNo');
            }
            result.data.topBar = urlParams('topBar') //h5模式的顶部header
            result.data.avatar = urlParams('avatar') // 是否显示头像
            // 如果开启了训前表单 先处理一下格式
            if (result.data.userFormMode && result.data.userFormConfig) {
                try {
                    result.data.userForm = JSON.parse(result.data.userFormConfig)
                } catch (e) {
                    result.data.userForm = {}
                }
            }
            store.dispatch('setInitData', result.data);
            document.title = result.data.titleDesc || window.vm.$i18n.t('userQuestion')
            // 如果没有userId 说明是新进访客
            let storage = new Storage();
            let userId = '';
            let userIdCompanyId = storage.getItem('userId');
            if (userIdCompanyId) {
                const com = userIdCompanyId.split('&')[0];
                if (com === companyId) {
                    userId = userIdCompanyId.split('&')[1]
                }
            }
            // 如果是iframe嵌入处理窗口位置
            if (urlParams('from') === 'iframeTest') {
                window.parent.postMessage(result.data, "*");
                //如果是 组件对接过来的第一次不加载
                return
            }
            this.isShowIframe = true; // 设置非组件对接
            let param = {
                channelId: urlParams('channelId'),
                pid: urlParams('pid'),
                params: urlParams('params'),
                userName: urlParams('userName'),
                userId: userId || '',
                email: urlParams('email'),
                phone: urlParams('phone'),
                groupId: urlParams('groupId'),
                adminId: urlParams('adminId'),
                locale: urlParams('locale') || 'zh',
            }
            try {
                if (urlParams('from') === 'iframe') {
                    param.refer = window.parent.location.href;
                }
            } catch (e) {
                console.log(e)
            }
            if (result.data.videoFlag) {
                let script = document.createElement('script');
                let script1 = document.createElement('script');
                let script2 = document.createElement('script');
                script.type = 'text/javascript';
                script1.type = 'text/javascript';
                script2.type = 'text/javascript';
                script.src = 'https://cdn.ronghub.com/RongIMLib-v2-Adapter-5.3.3.prod.js';
                script1.src = 'https://cdn.ronghub.com/RCRTC-5.3.12.prod.js';
                script2.src = 'https://cdn.ronghub.com/RCCall-5.0.latest.js';
                document.getElementsByTagName('head')[0].appendChild(script);
                document.getElementsByTagName('head')[0].appendChild(script1);
                document.getElementsByTagName('head')[0].appendChild(script2);
            }
            request.setChatInit(param).then(data => {
                this.serverTime = data.data.serverTime;
                loading && loading.close();
                if (data.data.status === 2) {
                    this.isCustomer = true;
                    // 更新连接状态 用于评价判断
                    store.dispatch('setConnectStatus', 'manual');
                } else {
                    this.isCustomer = false;
                    // 更新连接状态 用于评价判断
                    store.dispatch('setConnectStatus', 'robot');
                }
                // 如果没有userId 说明是新客户 或者已经过期
                if (!userId) {
                    storage.setItem({
                        name: 'userId',
                        value: companyId + '&' + data.data.userId,
                        expires: 60000 * 60 * 20 * 7,
                    })
                    // 发送欢迎语
                    this.sendHelloMessage();

                } else {
                    // 不是新客户就获取会话信息
                    if (data.data.status) {
                        this.getChatMsg(data);
                    }
                    this.sendHelloMessage();
                }
                store.dispatch('setUserInfo', data.data);

                // 在线或者排队的时候开启轮训
                if (data.data.status === 2 || data.data.status === 3) {
                    // 更新连接状态 用于评价判断
                    // store.dispatch('setConnectStatus', 'manual');
                    // store.dispatch('setUserInfo', [{key: 'status', value: 2}]);
                    store.dispatch('setCustomer', { adminNick: data.data.adminNick });
                    this.transfer('', true, data.data.status)
                    // 人工开启消息轮询
                    // this.setIntervalFunction();
                    // } else if (data.data.status === 3) {
                    //     store.dispatch('setUserInfo', [{key: 'status', value: 3}]);
                    this.setIntervalFunction();
                } else {
                    if (data.data.status === 0) {   //未建立会话时判断离线消息
                        //调用离线接口做处理
                        const { pollId, userId } = data.data
                        request.getOfflineMsg({
                            pollId,
                            userId,
                        }).then(result => {
                            if (result.message === 'SUCCESS') {
                                const { msgList } = result.data
                                let msgData = msgList.map(item => ({
                                    ...item,
                                    senderType: 2,   //客服
                                    senderName: item.adminNick || store.state.initData.robotName
                                }))
                                if (msgData && msgData.length > 0) {
                                    msgData = [{
                                        senderType: 4,
                                        msgContent: window.vm.$i18n.t('leaveMessage'),
                                        msgTime: msgData[0].msgTime
                                    }].concat({
                                        senderType: 4,
                                        msgContent: dayjs(msgData[0]['msgTime']).format('YYYY-MM-DD HH:mm'),
                                        msgTime: msgData[0].msgTime
                                    }).concat(msgData)
                                }
                                store.dispatch("setChatList", msgData);
                            }
                        })
                    }
                    //非人工和排队时候判断接待模式
                    switch (result.data.receiveMode) {
                        case 0:
                            // 机器人优先
                            break
                        case 1:
                            // 1人工优先
                            // this.transfer()
                            this.chatForm();
                            break
                        case 2:
                            // 2仅机器人 隐藏了转仍工按钮
                            break
                        case 3:
                            // 3仅人工
                            store.dispatch('setConnectStatus', 'manual');
                            this.chatForm()
                            break
                    }
                }
                // 引导问题
                this.robotGuideMessage();
                // timeLineFn(store, +new Date(), true);
                //注册一个监听 事件
                window.addEventListener('message', e => {
                    if (e.data.updateUser) {
                        this.updateUserInfo(e.data.updateUser)
                    } else if (e.data.showIframe) {
                        console.log('显示iframe')
                        this.isShowIframe = true;
                        this.readMessage(); // 设置已读消息 并且滚动到最下面
                        setTimeout(() => {
                            document.getElementsByClassName("scroll_iframe_auto_bottom")[0].scrollIntoView();
                        }, 1000);
                        if(!store.state.chatStatus){
                            window.location.reload();
                        }
                    }
                })
            }).catch(error => {
                console.log(error)
            })
        })
    },
    // 处理训前表单
    chatForm() {
        //如果开启了 判断使用场景
        // 新用户弹出 还是每次都弹出
        if (store.state.initData.userFormMode && store.state.initData.userFormConfig) {
            if (store.state.initData.userForm && store.state.initData.userForm.formModal) {
                // 1 每次都弹
                store.dispatch('setShowFormChat', true);
                store.dispatch("setShowChannelGroup", true);
            } else {
                //  0 首次弹
                if (!store.state.userInfo.userFormMode && store.state.initData.userFormConfig) {
                    store.dispatch('setShowFormChat', true);
                    store.dispatch("setShowChannelGroup", true);
                } else {
                    this.transfer()
                }
            }

        } else {
            this.transfer()
        }
    },
    submitUserForm(data) {
        data.userId = store.state.userInfo.userId;
        request.submitUserForm(data).then(result => {
            store.dispatch('setShowFormChat', false);
            this.transfer()
        })
    },
    //初始化获取当前聊天信息
    getChatMsg(data) {
        const param = {
            userId: data.data.userId || store.state.userInfo.userId,
            sessionId: data.data.sessionId || store.state.userInfo.sessionId,
        }
        request.getChatMsg(param).then(result => {
            if (result.code === 200) {
                result.data.forEach(msg => {
                    //消息禁止评价
                    msg.disabled = 2;
                    // 多伦问题
                    if (msg.docPattern === 1) {
                        msg.docNode = JSON.parse(msg.docNode);
                        msg.answer = msg.docNode.nodeContent
                    } else if (msg.msgType === 3) {
                        // 单轮问题
                        // msg.msgContent =msg.msgContent
                    }
                })
                result.data.unshift({
                    senderType: 4,
                    msgContent: dayjs(result.data[0]['msgTime']).format('YYYY-MM-DD HH:mm'),
                    msgTime: result.data[0]['msgTime']
                })
                store.dispatch('setInitList', result.data)
                store.dispatch('setScrollBottom')
                // 获取完当前消息后添加欢迎语

                // 设置定时任务触发自动应答  根据最后一条消息类型判断开启客服超时还是客户超时
                if (result.data.length > 0) {
                    let lastMsg = result.data[result.data.length - 1]
                    // 必须是人工模式
                    if (store.state.userInfo.status === 2) {
                        // 最后一条是客服发送
                        if (lastMsg.senderType === 2) {
                            this.setTimeOutMsg('userTimeoutMode')
                        } else if (lastMsg.senderType === 1) {
                            this.setTimeOutMsg('adminTimeoutMode')
                        }
                    }
                }
                // timeLineFn(store, +new Date(), true);
                // if (store.state.userInfo.status === 3) {
                //     let waitMsg = '客服已经忙翻啦！'
                //     if (store.state.initData.userQueueMode) {
                //         waitMsg = store.state.initData.userQueueMsg
                //     }
                //     const message = {
                //         senderType: 4,
                //         type: 1,
                //         id: 'waiting',
                //         msgContent: waitMsg,
                //     }
                //     store.dispatch('setChatList', message)
                // }
                //先注释这个常见问题不然会重复
                // if (store.state.initData.faq) {
                //     const message2 = {
                //         senderType: 2,
                //         msgType: 99,
                //         msgTime: new Date().getTime(),
                //         senderName: store.state.initData.robotName,
                //         msgContent: JSON.parse(store.state.initData.faq.showContent),
                //         suggestList: JSON.parse(store.state.initData.faq.showContent),
                //         menubar: JSON.parse(store.state.initData.faq.showContent),
                //         showType: store.state.initData.faq.showType
                //     }
                //     message2.suggestList.forEach(item => {
                //         if (item.docQuestion) {
                //             item.question = item.docQuestion
                //         }
                //     })
                //     store.dispatch('setChatList', message2);
                //     setTimeout(() => {
                //         document.getElementsByClassName("scroll_iframe_auto_bottom")[0].scrollIntoView();
                //     }, 1000);
                // }

            }

        })
    },
    updateUserInfo(data) {
        if (data.locale) {
            window.vm.$i18n.locale = data.locale || 'zh';
        } else {
        data.userId = store.state.userInfo.userId;
        data.pollId = store.state.userInfo.pollId;
        request.resetUser(data).then(result => {
        })
        }

    },
    getLeaveMsg(cbk) {
        const param = {
            userId: store.state.userInfo.userId,
        }
        request.getLeaveMsg(param).then(result => {
            if (result.code === 200) {
                cbk && cbk(result)
            }

        })
    },
    // 发消息
    sendMessage(message) {
        const userInfo = store.state.userInfo;
        store.dispatch('setScrollBottom')
        // 判断机器人还是人工 或者  排队中  0离线， 1机器人， 2在线， 3排队
        if (userInfo) {
            // 如果非离线 把消息推送到列表中
            if (userInfo.status === 2 || store.state.initData.receiveMode === 3) {
                // 发送消息之前清除 客户超时提示
                this.clearTimeOutMsg('userTimeoutTimeId')

                const msgCus = {
                    msgContent: message.msgContent.trim(),
                    msgType: message.msgType || 1, //消息类型：1.文字，2图片，3富文本，4文件，5音频，6视频
                    userId: userInfo.userId,
                    fileName: message.fileName,
                    // senderType: 1, //发送者类型：1用户，2客服，3机器人 4 暂定系统消息
                }
                // 文本或者富文本需要过滤敏感词
                if (msgCus.msgType === 1 || msgCus.msgType === 3) {
                    request.sendCustomMsg(msgCus).then(result => {
                        // 设置客服超时
                        this.setTimeOutMsg('adminTimeoutMode')
                        let messageStatus = {
                            id: message.id,
                            status: 'failed'
                        }
                        // 如果成功 把消息状态设置为完成 否者 失败
                        if (result.code === 200) {
                            messageStatus.status = 'success';
                        }
                        store.dispatch('updateChatItemStatus', messageStatus)
                        store.dispatch('setEnableEvaluate', true)
                    })

                    // request.msgSensitive({msgContent: msgCus.msgContent}).then(res => {
                    //     if (res.code === 200) {
                    //     }
                    //     else {
                    //         //业务不需要提示了
                    //         let str = msgCus.msgContent;
                    //         try {
                    //             str = str.replaceAll(`${res.data[0]}`, `<span style="color:red">${res.data[0]}</span>`)
                    //             store.dispatch('updateChatItemTips', {message: str, id: message.id})
                    //         } catch (e) {
                    //
                    //         }
                    //         let messageStatus = {
                    //             id: message.id,
                    //             status: 'failed'
                    //         }
                    //         store.dispatch('updateChatItemStatus', messageStatus)
                    //     }
                    // })
                    // } else {

                } else {
                    request.sendCustomMsg(msgCus).then(result => {
                        // 设置客服超时
                        this.setTimeOutMsg('adminTimeoutMode')
                        let messageStatus = {
                            id: message.id,
                            status: 'failed'
                        }
                        // 如果成功 把消息状态设置为完成 否者 失败
                        if (result.code === 200) {
                            messageStatus.status = 'success';
                        }
                        store.dispatch('updateChatItemStatus', messageStatus)
                        store.dispatch('setEnableEvaluate', true)
                    })
                }
            } else if (userInfo.status !== 2 && store.state.initData.receiveMode !== 3) {
                const msgRob = {
                    question: message.msgContent.trim(),
                    robotNo: store.state.initData.robotNo,
                    docId: message.docId,
                    itemId: message.itemId,
                    click: message.click,
                    userId: userInfo.userId,
                }
                if(message.nodeId){
                    msgRob.nodeId = message.nodeId
                }
                const lastMsg = store.getters.getLastMessage;
                if (lastMsg) {
                    // 清空最后消息
                    store.dispatch('setLastMessage', null)
                    if (lastMsg.nodeType !== 1 && lastMsg.itemList[0] && lastMsg.itemList[0].itemId) {
                        msgRob.itemId = lastMsg.itemList[0].itemId
                    }
                }

                if (store.getters.getChatList.length) {
                    let lastRobotMsg = store.getters.getChatList[store.getters.getChatList.length - 2]
                    if (lastRobotMsg.docPattern === 1 && lastRobotMsg.docNode && lastRobotMsg.docNode.itemList && lastRobotMsg.docNode.itemList.length) {
                        msgRob.nodeId = lastRobotMsg.docNode.nodeId;
                    }
                }
                // 清空输入联想
                store.dispatch('setRobotTips', []);
                request.sendRobotMsg(msgRob).then(result => {
                    store.dispatch('setScrollBottom')
                    // status 0会话已结束，1正常，2已是在线状态，-1命中转人工
                    if (!result.data) result.data = {};
                    // 如果成功 把消息状态设置为完成 否者 失败
                    let messageStatus = {
                        id: message.id,
                        status: 'failed'
                    }
                    // 如果成功 把消息状态设置为完成 否者 失败
                    if (result.code === 200) {

                        messageStatus.status = 'success';
                        store.dispatch('updateChatItemStatus', messageStatus);
                        if (result.data.status === 0) { //会话结束
                            location.reload();
                        } else if (result.data.status === -1) { //-1命中转人工
                            // this.transfer({groupId: ''})
                            this.chatForm()
                        } else {
                            store.dispatch('setEnableEvaluate', true)
                            if (result.data.docPattern === 1) {
                                result.data.answer = result.data.docNode.nodeContent
                                //    如果是多伦的内容展示、页面展示 记住当前的节点 回复消息的时候吧id带上
                                if (result.data.docNode.nodeType !== 1) {
                                    store.dispatch('setLastMessage', result.data.docNode)
                                }
                            } else {
                            }
                            // 回答类型answerType，0未知回答，1直接回答，2引导回答，-1基本寒暄，-2互联网寒暄
                            // robotAnswerTransferUserMode 直接回答 0 不转人工 1显示转人工按钮
                            // robotGuideTransferUserMode 引导回答0 不转人工 1显示转人工按钮 2 转人工
                            // robotUnknownTransferUserMode 未知回答0 不转人工 1显示转人工按钮 2 转人工
                            // robotUnderstandTransferUserMode 理解回答0 不转人工 1显示转人工按钮 2 转人工 （answerType未知）

                            if (result.data.answerType == 1 && store.state.initData.robotAnswerTransferUserMode) {
                                result.data.showTransferBtn = 1;
                            } else if (result.data.answerType == 2) {
                                if (store.state.initData.robotGuideTransferUserMode == 1) {
                                    result.data.showTransferBtn = 1;
                                } else if (store.state.initData.robotGuideTransferUserMode == 2) {
                                    setTimeout(() => {
                                        chatApi.chatForm();
                                    }, 1000)
                                }
                            } else if (result.data.answerType == 0) {
                                if (store.state.initData.robotUnknownTransferUserMode == 1) {
                                    result.data.showTransferBtn = 1;
                                } else if (store.state.initData.robotUnknownTransferUserMode == 2) {
                                    setTimeout(() => {
                                        chatApi.chatForm();
                                    }, 1000)
                                }
                            }
                            result.data.disabled = false;
                            result.data.senderType = 3;
                            result.data.senderName = store.state.initData.robotName;
                            result.data.msgType = result.data.msgType || 1; // 默认是文本类型
                            result.data.msgTime = new Date().getTime(); // 默认是文本类型
                            if (result.data.msgType === 9) {
                                result.data.msgContent = result.data.msgContent || result.data.answer
                            }
                            store.dispatch('setChatList', result.data);
                        }
                    }
                })
            }
        }

    },
    // 欢迎语
    sendHelloMessage(adminNick, status, groupId) {
        // store.dispatch('setChatList', {
        //     senderType: 4,
        //     msgContent: dayjs(+new Date()).format('YYYY-MM-DD HH:mm')
        // });
        // 是否开启欢迎语  是机器人模式还是人工模式
        try {
            if (store.state.userInfo.status === 2) {
                if (store.state.initData.adminWelcomeMode && adminNick && !this.isCustomer) {
                    const message = {
                        senderType: 2,
                        msgType: 1,
                        msgTime: new Date().getTime(),
                        senderName: adminNick,
                        msgContent: store.state.initData.adminWelcomeMsg || window.vm.$i18n.t('helloMsg'),
                    }
                    store.dispatch('setChatList', message);
                }
            } else {
                // } else if (store.state.userInfo.status === 1 || store.state.userInfo.status === 0) {
                if (store.state.initData.robotWelcomeMode && store.state.initData.receiveMode !== 3) {
                    const message = {
                        senderType: 3,
                        msgType: 1,
                        msgTime: new Date().getTime(),
                        senderName: store.state.initData.robotName,
                        msgContent: store.state.initData.robotWelcomeMsg,
                    }
                    store.dispatch('setChatList', message);
                }
            }
        } catch (e) {

        }
    },
    // 机器人推荐
    robotGuideMessage() {
        setTimeout(() => {
            try {
                if (store.state.initData.faq) {
                    const message2 = {
                        senderType: 2,
                        msgType: 99,
                        msgTime: new Date().getTime(),
                        senderName: store.state.customer.adminNick || store.state.initData.robotName,
                        msgContent: JSON.parse(store.state.initData.faq.showContent),
                        suggestList: JSON.parse(store.state.initData.faq.showContent),
                        menubar: JSON.parse(store.state.initData.faq.showContent),
                        showType: store.state.initData.faq.showType
                    }
                    message2.suggestList.forEach(item => {
                        if (item.docQuestion) {
                            item.question = item.docQuestion
                        }
                    })
                    store.dispatch('setChatList', message2);
                    setTimeout(() => {
                        document.getElementsByClassName("scroll_iframe_auto_bottom")[0].scrollIntoView();
                    }, 1000);
                }
            } catch (e) {

            }
        }, 1000)

    },
    // 转人工  技能组 ，类型 ，状态
    transfer(group, type, status) {
        let adminId = urlParams('adminId');
        //type 用来控制是否显示 分组接待
        // 清空联想
        store.dispatch('setRobotTips', [])
        // 开启了分组接待 并且没有指定坐席
        if (!group && store.state.initData.groupMode === 1 && !type && !adminId) {
            //   获取渠道技能组
            this.getChannelGroup();
        } else {
            store.dispatch("setShowChannelGroup", false);
            // 直接转人工
            let groupId = urlParams('groupId');
            if (group) {
                groupId = groupId || group.groupId
            }
            const param = {
                userId: store.state.userInfo.userId,
                groupId: groupId,
                adminId
            }
            //如果已经是人工 就直接返回
            if (store.state.userInfo.status === 2 && store.state.adminId) {
                return
            }
            request.transferConnect(param).then(result => {
                if (result.code === 200) {
                    store.commit('getAdminId', result.data.adminId)
                    store.dispatch('setScrollBottom')
                    if (result.data.status === 1) {
                        const message = {
                            senderType: 4,
                            type: 1,
                            msgTime: new Date().getTime(),
                            msgContent: window.vm.$i18n.t('noCustomer'),
                        }
                        if (store.state.initData.adminOfflineMode) {
                            message.msgContent = store.state.initData.adminOfflineMsg
                        }
                        store.dispatch('setChatList', message);

                        request.sysMsg({
                            "msgContent": window.vm.$i18n.t('noCustomer'),
                            "msgType": 111,
                            "userId": store.state.userInfo.userId,
                            "clientType": 2
                        })

                    } else if (result.data.status === 2) {
                        // 设置当前连接状态为客服
                        store.dispatch('setConnectStatus', 'manual');
                        let param = {
                            msgContent: window.vm.$i18n.t('customer') + ` ${result.data.adminNick} ` + window.vm.$i18n.t('connectChat'),
                            senderType: 4,
                            type: 1
                        }


                        request.sysMsg({
                            "msgContent": window.vm.$i18n.t('customer') + ` ${result.data.adminNick} ` + window.vm.$i18n.t('connectChat'),
                            "msgType": 100,
                            "userId": store.state.userInfo.userId,
                            "clientType": 2
                        })

                        store.dispatch('setChatList', param)
                        // 更新客服信息
                        store.dispatch('setCustomer', result.data);
                        // 更新当前用户状态
                        store.dispatch('setUserInfo', [{ key: 'status', value: 2 }]);
                        // 提示音
                        if (store.state.enablePlayAudio) {
                            if (this.transferAudio) {
                                this.transferAudio.play()
                            }
                        }
                        // 获取当前会话消息后添加欢迎语
                        this.sendHelloMessage(result.data.adminNick, status, groupId)
                        // 设置客户超时应答
                        this.setTimeOutMsg('userTimeoutMode')
                        // 如果页面有卡片信息 显示卡片消息
                        if (urlParams('card_title') && urlParams('card_url') && urlParams('card_picture')) {
                            let card = {
                                title: urlParams('card_title'),
                                desc: urlParams('card_desc'),
                                price: urlParams('card_price'),
                                picture: urlParams('card_picture'),
                                url: urlParams('card_url'),
                                id: 'message' + new Date().getTime(),
                                msgType: 'card'
                            }
                            store.dispatch('setChatList', card)
                        }

                        // 开启消息轮询
                        this.setIntervalFunction()
                    } else if (result.data.status === 3) {
                        window.onbeforeunload = null;
                        // window.onbeforeunload = (event) => {
                        //     request.leavePage({userId: store.state.userInfo.userId})
                        //     // return event.returnValue = window.vm.$i18n.t('isSureLeave');
                        // }
                        // 更新当前用户状态
                        store.dispatch('setUserInfo', [{ key: 'status', value: 3 }]);
                        // 如果是排队用户 刷新排队人数
                        let waitMsg = window.vm.$i18n.t('busyMessage')
                        if (store.state.initData.userQueueMode) {
                            waitMsg = store.state.initData.userQueueMsg
                        }
                        const message = {
                            senderType: 4,
                            type: 1,
                            id: 'waiting',
                            msgContent: waitMsg,
                        }
                        store.dispatch('setChatList', message);

                        request.sysMsg({
                            "msgContent": waitMsg,
                            "msgType":123,
                            "userId": store.state.userInfo.userId,
                            "clientType": 2
                        })

                        // 开启消息轮询
                        setTimeout(() => {
                            this.setIntervalFunction()
                        }, 500)
                    } else if (result.data.status === 4) {
                        //  非工作时间段
                        const message = {
                            senderType: 4,
                            type: 1,
                            msgContent: window.vm.$i18n.t('transferFailed'),
                        }
                        store.dispatch('setChatList', message)

                        request.sysMsg({
                            "msgContent": window.vm.$i18n.t('transferFailed'),
                            "msgType": 222,
                            "userId": store.state.userInfo.userId,
                            "clientType": 2
                        })

                    } else if (result.data.status === 5) {
                        //  非工作时间段
                        let msg = window.vm.$i18n.t('notWork')
                        if (store.state.initData.unWorkingMsg) {
                            msg = store.state.initData.unWorkingMsg
                        }
                        const message = {
                            senderType: 4,
                            type: 1,
                            msgContent: msg,
                        }
                        store.dispatch('setChatList', message);

                        request.sysMsg({
                            "msgContent": msg,
                            "msgType": 333,
                            "userId": store.state.userInfo.userId,
                            "clientType": 2
                        }).then(res => {

                        })

                    }
                }
            })
        }
    },
    // 发送对象类型数据
    sendJson(obj) {
        let param = {
            actor: '',
            msgContent: JSON.stringify(obj),
            senderType: 1, // 发送人 1用户，2客服，3机器人
            msgTime: new Date().getTime(),
            date: new Date().getTime(),
            sysType: '', // 系统消息类型
            msgType: 3, // 消息类型 3 富文本
            status: 'loading', // 消息状态 成功后隐藏否则一直loading
            id: 'message' + new Date().getTime()
        }
        store.dispatch('setChatList', param)
        this.sendMessage(param);
    },
    // 留言
    leaveMessage() {
    },
    // 获取评价配置
    getEvaluateMsg(cbk) {
        // 目前没有机器人配置  只获取人工的
        if (store.state.connectStatus !== 'robot') {
            request.msgEvaluate({
                tenantId: store.state.initData.tenantId,
                channelId: store.state.initData.channelId,
            }).then(data => {
                if (data.code === 200) {
                    // data.data.scoreList
                    data.data.starList = data.data.starList.reverse();
                    data.data.scoreList = data.data.scoreList.reverse();
                    data.data.starList.forEach(item => {
                        item.select = item.levelTag.split(',') || [];
                        item.select = item.select.map(tag => {
                            let str = tag;
                            return {
                                name: tag,
                                value: 0
                            }
                        })
                    })
                    data.data.scoreList.forEach(item => {
                        item.select = item.levelTag.split(',') || [];
                        item.select = item.select.map(tag => {
                            let str = tag;
                            return {
                                name: tag,
                                value: 0
                            }
                        })
                    })
                    store.dispatch('setEvaluate', data.data);
                    cbk && cbk()
                }
            })
        } else {
            cbk && cbk()
        }
    },
    // 结束会话
    closeChatSession(cbk) {
        this.clearTimeOutMsg();
        const param = {
            userId: store.state.userInfo.userId
        }
        //如果已经结束直接返回
        if (store.state.chatStatus === 0) {
            return
        }
        request.closeChatVisitor(param).then(result => {
            store.dispatch('setStatus', 0);
            cbk && cbk();
        })
    },
    // 轮训定时器
    setIntervalFunction() {
        if (this.intervalId) {
            clearTimeout(this.intervalId);
            this.intervalId = null;
        }
        setTimeout(() => {
            this.intervalMessage();
        })
        this.intervalId = setTimeout(() => {
            this.setIntervalFunction();
        }, 2000)
    },
    // 轮训方法
    intervalMessage() {
        try {
            const param = {
                userId: store.state.userInfo.userId,
                pollId: store.state.userInfo.pollId,
            }
            request.setChatEventMsg(param).then(result => {
                if (result.code === 200) {
                    // 如果在排队刷新排队人数
                    if (result.data.status === 3) {
                        let waitMsg = window.vm.$i18n.t('busyMessage')
                        if (store.state.initData.userQueueMode) {
                            waitMsg = store.state.initData.userQueueMsg
                        }
                        waitMsg = waitMsg.replace(/##/, result.data.waitIndex)
                        const message = {
                            senderType: 4,
                            type: 1,
                            id: 'waiting',
                            msgContent: waitMsg,
                        }
                        store.dispatch('updateMessageLast', message);

                        request.sysMsg({
                            "msgContent": waitMsg,
                            "msgType": 123,
                            "userId": store.state.userInfo.userId,
                            "clientType": 2
                        })
                    }
                    if (result.data.msgList.length > 0) {
                        store.dispatch('setScrollBottom')
                    }
                    // 处理消息 msgList
                    this.dealMessageList(result.data.msgList);
                    // store.dispatch('setCustomer', {adminNick: result.data.adminNick});
                }

            })
        } catch (e) {

        }
    },
    //处理循环的消息
    dealMessageList(list) {
        if (list && list.length > 0) {
            // event_type事件类型：1200-会话建立（排队中进入或者排队中被邀请），
            list.map(message => {
                if (message.event_type === 1202) {
                    // 1202-会话结束  outType结束方式：1会话超时，2客服结束，3新窗口打开
                    // 清除所有超时提示
                    this.clearTimeOutMsg()
                    message.senderType = 4;
                    message.type = 1; // 1 无背景 2有背景色
                    if (message.outType === 2) {
                        if (store.state.initData.adminCloseMode) {
                            message.msgContent = store.state.initData.adminCloseMsg
                        } else {
                            message.msgContent = window.vm.$i18n.t('closeChat');
                        }
                        if (urlParams("inviteEvaluate")) {
                            // 先提示评价
                            chatApi.inviteEvaluate();
                        }
                    } else if (message.outType === 1) {
                        message.msgContent = store.state.initData.userOverMsg;
                        if (urlParams("inviteEvaluate")) {
                            // 先提示评价
                            chatApi.inviteEvaluate();
                        }
                    } else if (message.outType === 3) {
                        message.msgContent = window.vm.$i18n.t('newWindow');
                    } else {
                        message.msgContent = window.vm.$i18n.t('chatOver');
                    }
                    store.dispatch('setChatList', message);

                    request.sysMsg({
                        "msgContent": message.msgContent,
                        "msgType": 999,
                        "userId": store.state.userInfo.userId,
                        "clientType": 2
                    })

                    store.dispatch('setStatus', 0);
                    // 更新客户状态
                    store.dispatch('setUserInfo', [{ key: 'status', value: 0 }]);
                    // 清除轮训
                    clearTimeout(this.intervalId)
                    this.intervalId = null;
                } else if (message.event_type === 1200) {
                    // 会话建立 排队中进入或者排队中被邀请
                    if (store.state.userInfo.status === 3) {
                        store.dispatch('setUserInfo', [{ key: 'status', value: 2 }]);
                        let param = {
                            msgContent: window.vm.$i18n.t('customer') + ` ${message.adminNick} ` + window.vm.$i18n.t('connectChat'),
                            id: 'waiting'
                        }
                        store.dispatch('updateMessageLast', param)
                        // 发送欢迎语
                        this.sendHelloMessage(message.adminNick)
                        // if(store.state.adminWelcomeMode){
                        //     let msg = {
                        //         msgContent: store.state.adminWelcomeMsg,
                        //         senderType: 3,
                        //         msgType: 1,
                        //         senderName : message.adminNick
                        //     }
                        //     store.dispatch('setChatList', msg)
                        // }
                    }
                    // 设置用户自动应答
                    this.setTimeOutMsg('userTimeoutMode')
                    //    提示音
                    if (store.state.enablePlayAudio) {
                        if (this.transferAudio) {
                            this.transferAudio.play()
                        }
                    }
                } else if (message.event_type === 1201) {
                    //1201-收到新消息
                    //如果当前是客服敏感词不显示
                    if (message.sensitiveFlag === 1) {
                        return
                    }
                    // 清除客服超时，设置客户超时
                    this.clearTimeOutMsg('adminTimeoutTimeId')
                    this.setTimeOutMsg('userTimeoutMode')
                    message.senderType = 2;
                    message.id = message.msgId;
                    message.faceUrl = store.state.customer.adminFace;
                    message.senderName = message.adminNick;
                    store.dispatch('setChatList', message);
                    //    提示音
                    if (store.state.enablePlayAudio) {
                        if (this.messageAudio) {
                            this.messageAudio.play()
                        }
                    }
                    //    改变标题 提示
                    this.tipTitle()

                    // 如果是iframe嵌入处理窗口位置
                    if (urlParams('from') === 'iframe') {
                        // 收到新消息 按钮旁边增加图标
                        window.parent.postMessage({ kld_num: true }, "*");
                    }
                    setTimeout(() => {
                        store.dispatch("setScrollBottom");
                        if (store.state.visibility) {
                            this.readMessage()
                        }
                    }, 1000)
                } else if (message.event_type === 1203) {
                    //    1203-被客服邀请满意度评价
                    this.getEvaluateMsg(() => {
                        store.dispatch('setConfigPc', [{ key: 'showModal', value: true }, {
                            key: 'evaluateModal',
                            value: true
                        }])
                    })
                } else if (message.event_type === 1204) {
                    // 显示正在输入 2s后 隐藏  如果已经显示 不在做处理
                    if (!store.state.agentTyping) {
                        store.dispatch('setAgentTyping', true);
                        setTimeout(() => {
                            store.dispatch('setAgentTyping', false);
                        }, 2000)
                    }

                } else if (message.event_type === 1205) {
                    // 客服测回消息
                    store.dispatch('deleteChatItemStatus', { msgId: message.msgId });
                    const msg = {
                        senderType: 4,
                        type: 1,
                        msgContent: window.vm.$i18n.t('backMessage'),
                    }
                    store.dispatch('setChatList', msg);

                    request.sysMsg({
                        "msgContent": window.vm.$i18n.t('backMessage'),
                        "msgType": 1,
                        "userId": store.state.userInfo.userId,
                        "clientType": 2
                    })

                } else if (message.event_type === 1207) {
                    store.commit('getVideoAdminId', message.aminId)
                } else if (message.event_type === 1208) {
                    store.commit('error', 1) //客服不同意会话邀请
                }
            })
        }
    },
    // 发送评价
    sendEvaluate(param) {
        param.userId = store.state.userInfo.userId;
        request.sendEvaluate(param).then(result => {
            if (result.code === 200) {
                store.dispatch('setConfigPc', [{ key: 'showModal', value: false }, { key: 'evaluateModal', value: false }])
                let message = {};
                message.senderType = 4;
                message.type = 1; // 1 无背景 2有背景色
                message.msgContent = window.vm.$i18n.t('thankMessage');
                store.dispatch('setChatList', message)

                request.sysMsg({
                    "msgContent": window.vm.$i18n.t('thankMessage'),
                    "msgType": 555,
                    "userId": store.state.userInfo.userId,
                    "clientType": 2
                })
            }
        })
    },
    // 正在输入
    userTyping(param) {
        param.userId = store.state.userInfo.userId;
        if (this.timeTyping) {
            clearTimeout(this.timeTyping)
        }
        this.timeTyping = setTimeout(() => {
            request.userTyping(param)
        }, 300)
    },
    // 历史记录
    getHistoryList(param) {
        store.dispatch('setLoadingStatus', 'loadStart');
        let firstMes = store.state.chatList[0]
        if (firstMes && firstMes.msgTime) {
            // 把第一条记录的时间作为查询参数
            param.maxTime = firstMes.msgTime;
        } else {
            // 如果开始没有数据 把当前时间做为查询参数
            param.maxTime = this.serverTime
        }
        param.userId = store.state.userInfo.userId;
        store.dispatch('setLoadingStatus', 'loading')
        request.getChatHistoryMsg(param).then(result => {
            if (result.code === 200) {
                if (result.data.length) {
                    result.data.forEach(msg => {
                        try {
                            // 多轮问题
                            msg.disabled = 2;
                            if (msg.docPattern === 1 && msg.docNode) {
                                msg.docNode = JSON.parse(msg.docNode);
                                msg.answer = this.dealAnswerInner(msg.docNode.nodeContent, msg.id)
                            } else if (msg.msgType === 3) {
                                msg.msgContent = this.dealAnswerInner(msg.msgContent, msg.id)
                            }
                        }catch (e) {

                        }

                    })
                    const timeStr = {
                        senderType: 4,
                        msgTime: result.data[result.data.length - 1]['msgTime'],
                        msgContent: dayjs(result.data[result.data.length - 1]['msgTime']).format('YYYY-MM-DD HH:mm')
                    }
                    result.data.push(timeStr)
                    store.dispatch('setChatList', result.data.reverse())
                }
                // 如果没有记录了
                if (result.data.length < param.pageSize) {
                    store.dispatch('setLoadingStatus', 'end')
                } else {
                    store.dispatch('setLoadingStatus', false)
                }
            } else {
                store.dispatch('setLoadingStatus', false)
            }
        })
    },
    // 上传文件
    uploadFile(file) {
        if (file.size > 5242880 * 2) {
            Message({
                message: window.vm.$i18n.t('fileMax'),
                type: 'error'
            })
            return
        }
        const that = this;
        const obj = {
            file: file,
            userId: store.state.userInfo.userId
        }
        request.uploadFile(obj).then(result => {
            if (result.code === 200) {
                const message = {
                    msgContent: result.data.url,
                    msgType: 1, //1.文字，2图片，3富文本，4文件，5音频，6视频
                    id: 'file' + new Date().getTime(),
                    msgTime: new Date().getTime(),
                    senderType: 1,
                    fileName: result.data.name,
                    status: 'loading'
                }
                // 判断是图片还是文件 音频 视频
                const imgFilter = "jpeg|gif|jpg|png|bmp|pic|svg|";
                const videoFilter = 'mp4|avi|mov|rmvb|rm|flv|3gp';
                const audioFilter = 'mp3|wav|ogg';
                if (imgFilter.indexOf(result.data.suffix.toLowerCase()) > -1) {
                    // 图片
                    message.msgType = 2;
                } else if (videoFilter.indexOf(result.data.suffix.toLowerCase()) > -1) {
                    // 视频
                    message.msgType = 6;
                } else if (audioFilter.indexOf(result.data.suffix.toLowerCase()) > -1) {
                    // 音频
                    message.msgType = 5;
                } else {
                    // 文件
                    message.msgType = 4
                }
                store.dispatch('setChatList', message)
                that.sendMessage(message);

            }
        })
    },
    // 拍照
    uploadImg(file) {
        const that = this;
        const obj = {
            file: file,
            userId: store.state.userInfo.userId
        }
        request.uploadFile(obj).then(result => {
            if (result.code === 200) {
                const message = {
                    msgContent: result.data.url,
                    msgType: 2, //2图片，5音频，6视频
                    id: 'file' + new Date().getTime(),
                    msgTime: new Date().getTime(),
                    senderType: 1,
                    fileName: result.data.name,
                    status: 'loading'
                }
                const imgFilter = "jpeg|gif|jpg|png|bmp|pic|svg|";
                const videoFilter = 'mp4|avi|mov|rmvb|rm|flv|3gp';
                const audioFilter = 'mp3|wav|ogg';
                if (imgFilter.indexOf(result.data.suffix.toLowerCase()) > -1) {
                    message.msgType = 2;
                } else if (videoFilter.indexOf(result.data.suffix.toLowerCase()) > -1) {
                    message.msgType = 6;
                } else if (audioFilter.indexOf(result.data.suffix.toLowerCase()) > -1) {
                    message.msgType = 5;
                }
                store.dispatch('setChatList', message)
                that.sendMessage(message);

            }
        })
    },
    // 机器人建议
    robotTips(param) {
        param.robotNo = store.state.initData.robotNo;
        param.userId = store.state.userInfo.userId;
        if ((param.question.trim()).length == 0) {
            return
        }
        request.robotTips(JSON.stringify(param)).then(result => {
            let arr = [];
            if (result.code === 200) {
                result.data.forEach(item => {
                    item.tips = item.tips.replace(/<rhi>/g, '<rhi style="color:#7467F0">')
                })
                arr = result.data
            }
            store.dispatch('setRobotTips', arr)
            //    设置定时清空联想
            setTimeout(() => {
                store.dispatch('setRobotTips', []);
            }, 6000)

        })
    },
    // 消息提示
    tipTitle() {
        let title = document.title;
        let flash_title = () => {
            //当窗口没焦点状态下才闪动
            if (document.hidden) {
                newMsgCount();
            } else {
                document.title = title
            }
        }
        //消息提示
        let flag = false;

        function newMsgCount() {
            if (flag) {
                flag = false;
                document.title = window.vm.$i18n.t('newMessage');
            } else {
                flag = true;
                // document.title = store.state.initData.tenantName;
            }
            window.setTimeout(() => {
                flash_title()
            }, 800);
        }

        setTimeout(() => {
            flash_title()
        }, 200); //2秒之后调用一次
    },
    // 获取渠道技能组
    getChannelGroup() {
        // 如果地址栏有技能组直接转人工
        let groupId = urlParams('groupId');
        if (groupId) {
            this.transfer({ groupId: groupId })
        } else {
            if (store.state.initData.groupConfig) {
                try {
                    let groupList = JSON.parse(store.state.initData.groupConfig);
                    if (groupList.length === 0) {
                        // 没有技能组
                        const message = {
                            senderType: 4,
                            type: 1,
                            msgContent: window.vm.$i18n.t('noCustomer'),
                        }
                        store.dispatch('setChatList', message);



                        request.sysMsg({
                            "msgContent": window.vm.$i18n.t('noCustomer'),
                            "msgType": 111,
                            "userId": store.state.userInfo.userId,
                            "clientType": 2
                        })

                    } else if (groupList.length === 1) {
                        let group = groupList[0]
                        // 只有一个直接转接
                        this.transfer(group);
                    } else {
                        store.dispatch('setChannelGroup', groupList)
                        store.dispatch('setShowChannelGroup', true)
                    }
                } catch (e) {
                }
            } else {
                this.transfer({ groupId: groupId })
            }
        }
    },
    // 设置超时  机器人超时和人工超时 目前只有人工客服有
    setTimeOutMsg(type) {
        let message = {
            senderType: 2,
            type: 1
        };
        if (type === 'userTimeoutMode') {
            // 用户超时提示
            if (store.state.initData.userTimeoutMode) {
                let time = store.state.initData.userTimeoutTime * 1
                this.clearTimeOutMsg('userTimeoutTimeId')
                this.userTimeoutTimeId = setTimeout(() => {
                    message.msgContent = store.state.initData.userTimeoutMsg;
                    message.senderName = store.state.customer.adminNick
                    store.dispatch('setChatList', message)

                    request.sysMsg({
                        "msgContent": message.msgContent,
                        "msgType": 1,
                        "userId":store.state.userInfo.userId,
                        'senderName': message.senderName,
                        "clientType": 3
                    })
                }, time * 60 * 1000)
            }
        }
        if (type === 'adminTimeoutMode') {
            // }
            // 客服超时提示
            if (store.state.initData.adminTimeoutMode) {
                let time = store.state.initData.adminTimeoutTime * 1
                this.clearTimeOutMsg('adminTimeoutTimeId')
                this.adminTimeoutTimeId = setTimeout(() => {
                    message.msgContent = store.state.initData.adminTimeoutMsg;
                    message.senderName = store.state.customer.adminNick;
                    store.dispatch('setChatList', message)

                    request.sysMsg({
                        "msgContent": message.msgContent,
                        "msgType": 1,
                        "userId":store.state.userInfo.userId,
                        'senderName': message.senderName,
                        "clientType": 3
                    })

                }, time * 60 * 1000)
            }
        }

    },
    // 清除超时提示  不传type 全部清除
    clearTimeOutMsg(type) {
        if (type === 'userTimeoutTimeId' || !type) {
            // 清除用户超时提示
            if (this.userTimeoutTimeId) {
                clearTimeout(this.userTimeoutTimeId)
                this.userTimeoutTimeId = null
            }
        }
        if (type === 'adminTimeoutTimeId' || !type) {
            // 清除客服超时提示
            if (this.adminTimeoutTimeId) {
                clearTimeout(this.adminTimeoutTimeId)
                this.adminTimeoutTimeId = null
            }
        }
    },
    dealAnswerInner(answer, id) {
        if (!answer) return answer;
        answer = answer.replace(/&amp;/g, '&').replace(/&amp/g, '&');
        let res = '';
        let wordArr = answer.split(/\s+/);
        for (let i = 0; i < wordArr.length; i++) {
            let tmp = (function (str) {
                let isHtml = false;
                let htmlTags = ['src=', 'href=']
                for (let i = 0; i < htmlTags.length; i++) {
                    if (str.indexOf(htmlTags[i]) >= 0) {
                        isHtml = true;
                    }
                }

                let regExp = /^(((https?):\/\/)(www))[a-zA-Z0-9_\-]+((\.(com|cn|org))|(:[0-9]{2,4}))?(:[0-9]{2,4})?([:\/\(\)\?\.&\-=a-zA-Z0-9;#%_]+)?$/g;
                //是否能匹配出url 此处确对匹配
                if (!isHtml) {
                    if (str.match(regExp)) {
                        //判断是否添加 http 标签
                        if (!str.match(regExp)) {
                            str = '<a href="http://' + str + '" target="_blank">' + str + '</a>';
                        } else {
                            str = '<a href="' + str + '" target="_blank">' + str + '</a>';
                        }
                    } else {
                        let regExp1 = /((www.)|((https?):\/\/))[a-zA-Z0-9_\-]+((\.(com|cn|org))|(:[0-9]{2,4}))?(:[0-9]{2,4})?([:\/\(\)\?\.&\-=a-zA-Z0-9;#%_]+)?/g;
                        let regArr = str.match(regExp1);
                        let ret = regArr;
                        if (regArr && regArr.length > 0) {
                            //取出第一项的匹配
                            let indexNo = str.indexOf(regArr[0]);
                            //是否有 http开头
                            let isHttpNo = regArr[0].indexOf('http');
                            if (isHttpNo >= 0) {
                                ret = '<a href="' + regArr[0] + '" target="_blank">' + regArr[0] + '</a>';
                            } else {
                                ret = '<a href="http://' + regArr[0] + '" target="_blank">' + regArr[0] + '</a>';
                            }
                            //拼url
                            // let _str;
                            if (indexNo === 0) {
                                str = ret + str.substring(regArr[0].length, str.length);
                            } else {
                                let _str1 = str.substring(0, indexNo);
                                let _str2 = _str1 + regArr[0];
                                let _str3 = str.substring(_str2.length, str.length);
                                str = _str1 + ret + _str3;
                            }
                        }
                    }
                }
                return str + ' ';

            })(wordArr[i]);
            res += tmp;
        }
        answer = res;
        // 如果答案中包含其他关联问题 单独做点击处理
        if (answer && answer.indexOf('//question') > 0) {
            let div = document.createElement('div');
            let className = id ? id : 'answer' + new Date().getTime();
            div.innerHTML = answer;
            $(div).find('a').addClass(className).attr('onclick', 'return false');
            setTimeout(() => {
                $(document).on('click', '.' + className, (e) => {
                    className = null;
                    let active = e.currentTarget
                    if (active.hostname === 'question') {
                        // 单轮问题
                        const obj = {
                            msgContent: active.innerText,
                            senderType: 1, // 发送人 1用户，2客服，3机器人
                            date: new Date().getTime(),
                            msgTime: new Date().getTime(),
                            sysType: '', // 系统消息类型
                            msgType: 1, // 消息类型 1文本
                            status: 'loading', // 消息状态 成功后隐藏否则一直loading
                            id: 'message' + new Date().getTime()
                        }
                        //更新到聊天框
                        store.dispatch('setChatList', obj)
                        this.sendMessage(obj);
                    } else {
                        window.open(active.href, active.target)
                    }
                })
            }, 100)
            return div.innerHTML
        } else {
            return answer
        }
    },
    //  提交留言
    submitMessage(data, cbk) {
        if (!data.customerName) {
            Toast({
                message: window.vm.$i18n.t('inputUserName'),
                duration: 2000
            });
            return
        }
        // let phoneFormat = /^1[0-9]{10}$/;
        // if (!phoneFormat.test(data.customerPhone)) {
        //     Toast({
        //         message: window.vm.$i18n.t('inputUserPhone'),
        //         duration: 2000
        //     });
        //     return
        // }
        // let formatEmail = /^[a-zA-Z0-9]+([-_\.][a-zA-Z0-9]+)*(?:@(?!-))(?:(?:[a-zA-Z0-9-]*)(?:[a-zA-Z0-9](?!-))(?:\.(?!-)))+[a-zA-Z]{2,}$/
        // if (!formatEmail.test(data.customerEmail)) {
        //     Toast({
        //         message: window.vm.$i18n.t('inputUserEmail'),
        //         duration: 2000
        //     });
        //     return
        // }
        if (!data.msgContent) {
            Toast({
                message: window.vm.$i18n.t('inputLeaveMsg'),
                duration: 2000
            });
            return
        }
        data.userId = store.state.userInfo.userId;
        request.messageSub(data).then(result => {
            if (result.code === 200) {
                Toast({
                    message: window.vm.$i18n.t('submitSuc'),
                    duration: 2000
                });
                cbk && cbk()
            } else {
                Toast({
                    message: result.message,
                    duration: 2000
                });
            }
        })
    },
    inviteEvaluate(cbk) {
        let param = {
            "userId": store.state.userInfo.userId
        }
        request.isEvaluate(param).then(result => {
            if (!result.data) {
                this.getEvaluateMsg(() => {
                    store.dispatch('setConfigPc', [{ key: 'showModal', value: true }, {
                        key: 'evaluateModal',
                        value: true
                    }])
                })
            } else {
                cbk && cbk()
            }
        })
    },
    //已读消息
    readMessage() {
        //人工模式设置已读
        if (store.state.userInfo.status === 2 && this.isShowIframe) {
            let param = {
                userId: store.state.userInfo.userId,
                pollId: store.state.userInfo.pollId,
            }
            request.readMsg(param).then(result => {
            })
        }

    },
    evaluateKb(param, cbk) {
        let params = {
            "docId": param.docId,
            "isUseful": param.isUseful,
            "robotNo": store.state.initData.robotNo,
            sessionId: store.state.userInfo.sessionId,
            tenantId: store.state.initData.tenantId,
            userId: store.state.userInfo.userId,
        }
        request.visitorCommentDoc(params).then(result => {
            cbk && cbk()
        })
    }
}
export default chatApi



// WEBPACK FOOTER //
// ./src/components/methods/index.js